import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPage({ title, children }) {
    return (
        <div className="min-h-screen bg-powder text-ink py-24 md:py-32 px-5 md:px-12">
            <div className="max-w-3xl mx-auto">
                <Link to="/" className="inline-flex items-center gap-2 text-sm font-sans mb-10 editorial-link">
                    <ArrowLeft size={16} /> Torna alla home
                </Link>
                <h1 className="font-serif text-5xl md:text-7xl font-bold leading-[0.95] mb-10">
                    {title}
                </h1>
                <div className="prose prose-lg font-sans space-y-6 text-ink-muted leading-relaxed">
                    {children}
                </div>
            </div>
        </div>
    );
}
